import { useSelector } from 'react-redux';
import { selectUserProjectIsUuidBased } from 'core/userContext';

export const useIsUuidProject = () => useSelector(selectUserProjectIsUuidBased);
